import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true} style={{ maxWidth: "100%" }}>
          <Row>
            {/*<Col md={6}>{new Date().getFullYear()} © Q1Media.</Col>*/}
            <Col md={6}>
              <div className="text-sm-end d-none d-sm-block">
                </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  );
};

export default Footer;
